import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import MicrosoftDefenderForEndpointCredentialsForm from "./MicrosoftDefenderForEndpointCredentialsForm";
import MicrosoftDefenderForEndpointConfigListing from "./MicrosoftDefenderForEndpointConfigListing";

export default function MicrosoftDefenderForEndPointPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={MicrosoftDefenderForEndpointCredentialsForm}
      PullConfigListingView={MicrosoftDefenderForEndpointConfigListing}
    />
  );
}
